module.exports = __webpack_public_path__ + "img/singletrack-study-roadshow.4037203e.png";